module.exports = __webpack_public_path__ + "img/poster-ru80x40.82ec112e.jpg";